import { useEffect, useRef, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import useInbox from "hooks/useInbox.ts";
import { useSearchBar } from "hooks/useSearchBar.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { searchInObj, filterInObj } from "../../helpers.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer.js";
import InboxSideBar from "../../SideBar/InboxSideBar.js";
import StatusFilter from "../../Reusable/StatusFilter.tsx";
import { useUser } from "contexts/userContext/userContext.js";
import RecipientFilter from "../../Reusable/RecipientFilter.tsx";
import hasAdminAccessRights from "../../../../../helpers/hasAdminAccessRights.ts";
import { useAppSelector } from "store/hooks.ts";
import { selectTParam, selectFParam, selectSearchParams } from "store/selectors/inboxSelectors.ts";

const InboxMobileSearch = ({ setShowSearchBar }) => {
  const inputRef = useRef();

  const closeSearchMenuFunc = () => {
    setShowSearchBar(false);
  };

  const { handleSubmit, handleChange, searchValue, setSearchValue } =
    useSearchBar({ submitCallback: closeSearchMenuFunc });

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const handleClear = () => {
    if (searchValue.length > 0) {
      setSearchValue("");
    } else {
      closeSearchMenuFunc();
    }
  };

  return (
    <>
      <div className="form-wrapper">
        <div className="searchbar-submit-icon" onClick={handleSubmit}>
          <Icon name="search" darkGray />
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type=""
            value={searchValue}
            onChange={handleChange}
            ref={inputRef}
          />
        </form>
        <Icon name="x" gray onClick={handleClear} />
      </div>
    </>
  );
};

const MobileToolBar = () => {
  const {
    getMailsQuantity,
    getSelectedList,
    setPageCategory,
  } = useInbox();
  const pageType = useAppSelector(selectTParam);
  const pageCategory = useAppSelector(selectFParam);
  const searchParams = useAppSelector(selectSearchParams);
  const { getUserData } = useUser();
  const { getTextByKey, getDirection } = useContent();

  const { desktopCondition, tabletCondition } = useMediaQueries();
  const [showSideBar, setShowSideBar] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);

  useEffect(() => {
    setShowSideBar(false);
  }, [pageType]);

  const removeCategoryFilter = () => {
    setPageCategory("");
  };

  return desktopCondition || tabletCondition ? null : (
    <>
      {showSearchBar ? null : (
        <div className="main-part">
          <AnimationContainer
            animationOn={showSideBar}
            animationClassName="fade-in"
          >
            <div
              className={`sidebar-wrapper ${!showSideBar ? "transparent" : ""}`}
              onClick={() => setShowSideBar(false)}
            />
          </AnimationContainer>
          <AnimationContainer
            animationOn={showSideBar}
            animationClassName="inbox-sidebar-animation"
          >
            <InboxSideBar setShowSideBar={setShowSideBar} />
          </AnimationContainer>
          <div className="inbox-mobile-header">
            <div
              className="sidebar-icon"
              onClick={() => setShowSideBar((prev) => !prev)}
            >
              <Icon
                name="newInbox/arrows"
                style={{
                  transform: `rotate(${getDirection() === "ltr" ? 0 : 180}deg)`,
                }}
              />
            </div>
            {!searchParams?.q ? (
              <div className="inbox-header-title-mobile">
                <p>{getTextByKey(searchInObj[pageType])}</p>
                {!!pageCategory && (
                  <div className="inbox-path-text-container">
                    {getTextByKey(filterInObj[pageCategory])}
                    <Icon name="x" onClick={removeCategoryFilter} />
                  </div>
                )}
              </div>
            ) : (
              <div className="target-title">
                {getTextByKey("search-in")} '{searchParams?.q}'
                <span className="target-subtitle">
                  {getMailsQuantity()} {getTextByKey("search-results")}
                </span>
              </div>
            )}
            <div className="flex-spacer"></div>
          </div>
        </div>
      )}
      <div
        className={`search-part${
          pageCategory === "jform" ? " forms-filters-include" : ""
        }`}
      >
        {showSearchBar ? (
          <div className="search-collapse-container">
            <InboxMobileSearch setShowSearchBar={setShowSearchBar} />
          </div>
        ) : (
          <div
            className="search-mobile-element"
            onClick={() => setShowSearchBar((prev) => !prev)}
          >
            <Icon name="search" darkGray />
          </div>
        )}
      </div>
      <div className="mobile-filter-icons">
        <StatusFilter asIcon />
        {!getSelectedList()?.length &&
          hasAdminAccessRights(
            getUserData()?.isTopUser,
            getUserData()?.subUserRole
          ) &&
          pageType !== "picker" &&
          !showSearchBar && (
            <div className="recipient-filter-wrapper">
              <RecipientFilter />
            </div>
          )}
      </div>
    </>
  );
};
export default MobileToolBar;
